import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

/**
 * Custom hook to handle scrolling behavior based on popup states.
 * @param {Object} params
 * @param {boolean} params.showCancelPopUp
 * @param {boolean} params.showUnsavedChangesPopup
 * @param {boolean} params.showSaveExitCompletionPopup
 * @param {boolean} params.showSurgeryNonUsePopup
 * @param {boolean} params.showUNiDPopUp
 * @param {Function} params.hideScrolling
 * @param {Function} params.resumeScrolling
 */
export function useScrollingEffect({
    showCancelPopUp,
    showUnsavedChangesPopup,
    showSaveExitCompletionPopup,
    showSurgeryNonUsePopup,
    showUNiDPopUp,
    hideScrolling,
    resumeScrolling,
}) {
    useEffectWithErrorLogging(() => {
        if (
            showCancelPopUp ||
            showUnsavedChangesPopup ||
            showSaveExitCompletionPopup ||
            showSurgeryNonUsePopup ||
            showUNiDPopUp
        ) {
            hideScrolling();
        } else {
            resumeScrolling();
        }
    }, [
        showCancelPopUp,
        showUnsavedChangesPopup,
        showSaveExitCompletionPopup,
        showSurgeryNonUsePopup,
        showUNiDPopUp,
    ]);
}
